module.exports = __webpack_public_path__ + "69e276d82d3a834909ffe1161a36af5c.fbx";